<template>
  <div>
    <div class="items mt80">
        <p class="title">>>监护申请流程</p>
        <img src="../../static/img/flow.png" alt="">
    </div>
    <div class="items">
        <p class="title">>>监护申请流程</p>
        <p class="content" v-html="content"></p>
    </div>
    <div class="items mb80">
        <p class="title">>>监护服务申请书</p>
        <p class="formData">表单1：<span class="report" @click="download">海南搜易科技游戏未成年人用户家长监控服务申请书</span></p>
        <p class="content" v-html="books"></p>
    </div>
    <div class="pb80"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content:"监护人提出申请<br>\
                *在监护人发现被监护人有沉溺海南搜易科技游戏的情况下，监护人可向海南搜易科技公司申请发起未成年人家长监护机制。<br>\
                <br>\
                监护人 需亲自通过邮寄方式 向我司提供有效材料，向海南搜易科技公司提出未成年人账户监控的申请。在收到邮件后，我司即开始启动监护机制审核流程，首先进入疑似账号身份确认期。<br>\
                疑似账号身份确认期（15 个自然日）<br>\
                <br>\
                *在判断申请材料完整的情况下，我司将通过官方邮箱联系疑似帐号归属者，告知其在 15 个自然日内将按照监护人需求对其账号进行相关操作，并要求疑似账号归属者提供身份材料以便我司判定其与监护人监护关系；<br>\
                <br>\
                *若疑似账号归属者在 15 个自然日内不能提供有效身份证明或逾期提供，则默认为疑似账号归属者与被监护人身份相符。我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；<br>\
                <br>\
                *若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人相符，我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；<br>\
                <br>\
                *若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人不符，我司则无法判定其与被监 护人的身份关系。在此情况下，为保障用户游戏账号安全，我司将通知监护人通过公安机关出具账号找回协查证明，由我司协助被监护人找回游戏账号后再进行后续操作；",
      books:"温馨提醒，您在邮寄申请书时，要记得一起提供如下资料：<br>\
                附件1：申请人的身份证（复印件）<br>\
                附件2：被申请人的身份证（复印件）<br>\
                附件3：申请人与被申请人的监护法律关系证明文件（户口簿或者其他合法有效证明文件）"
    };
  },
  mounted: function() {
  },
  methods: {
    
      download() {
       this.$axios.get('/static/report.docx', {
          responseType: 'blob', //重要
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          let fname = '海南搜易科技未成年人用户家长监控服务申请书.docx';
          link.href = url;
          link.setAttribute('download', fname);
          document.body.appendChild(link);
          link.click();
        })
      }
  }
};
</script>
<style scoped>
.mt80{
    margin-top: 80px !important
}
.pb80{
    padding-bottom: 100px
}
.title {
  color: #ef653d;
  width: 900px;
  font-size: 20px;
  text-align: left;
  margin:0 auto;
}
.content {
  width: 900px;
  margin: 0 auto;
  padding: 20px 0 ;
  font-size: 15px;
  color: #5d5d5d;
  text-align: left;
  line-height: 25px;
}
.items{
    width: 900px;
    margin:0 auto;
    border:1px solid #ef653d;
    margin-top: 20px;
    border-radius: 10px;
    padding:20px 15px
}
.formData{
    width: 900px;
    margin: 0 auto;
    padding: 20px 0 0;
    font-size: 15px;
    color: #5d5d5d;
    text-align: left;
    line-height: 25px;
}
.report{
  cursor: pointer;
  color: #ef653d;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/sapplication.vue